import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=8b6cf6cc&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=8b6cf6cc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6cf6cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b6cf6cc')) {
      api.createRecord('8b6cf6cc', component.options)
    } else {
      api.reload('8b6cf6cc', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=8b6cf6cc&scoped=true", function () {
      api.rerender('8b6cf6cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/influencer_panel/Dashboard.vue"
export default component.exports